// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"32":"HomeView","186":"StudentHistoryView","490":"SendSMSView","558":"NotFoundView"}[chunkId] || chunkId) + "." + {"15":"1d3fff2b","32":"18c4c5a9","75":"d0ca947f","186":"608dac32","463":"f166f949","490":"5746aea2","558":"40a61241","787":"95e7b44c"}[chunkId] + ".chunk.js";
};